export default {
  /**
   * Converte data padrão brasileiro em formato ISO
   * @param {string} value string formatada dd/mm/yyyy
   * @returns retorna data no formato iso yyyy-mm-dd
   */
  convertDateToISO(value) {
    if (value) {
      const [day, month, year] = value.split('/');
      if (day && month && year) {
        const result = `${year}-${month}-${day}`;
        return result;
      }
    }
    return null;
  },

  /**
   * Converte data padrão ISO em formato brasileiro
   * @param {string} value string formatada yyyy-mm-dd[THH:mm:ss]
   * @returns retorna data no formatado brasileiro dd/mm/yyyy
   */
  converteISOToDate(value) {
    const positionT = value.indexOf('T');
    if (positionT > 0) {
      value = value.split('T')[0];
    }
    const [year, month, day] = value.split('-');
    if (day && month && year) {
      const result = `${day}/${month}/${year}`;
      return result;
    }
    return null;
  },
};
